import React from "react";
import styled from "styled-components";
import url from "url";

import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Link from "src/components/UI/Link";
import Text from "src/components/UI/Text";

const LinkListStyles = styled.div`
  a {
    color: ${(props) =>
      props.light ? props.theme.colors.light : props.theme.colors.dark};
  }

  span {
    ${(props) => props.theme.mixins.textElipsis}
    display: block;
  }
`;

const LinkListItem = styled(Link)`
  padding: ${(props) => props.theme.space[2]} 0;
  display: block;
  border-bottom: 1px solid ${(props) => props.theme.colors.light};
`;

const LinkList = ({ links, division, ...rest }) => {
  return (
    <LinkListStyles {...rest}>
      {links.map(({ label, link, display }, i) => {
        const host = link?.url
          ? url.parse(link.url).hostname.replace("www.", "")
          : "";
        const pathname = link?.url ? url.parse(link.url).pathname : "";
        const path =
          pathname.substr(-1) === "/"
            ? pathname.substr(0, pathname.length - 1)
            : pathname;
        const href = `${host}${path}`;
        if (display === division || display === "both") {
          return (
            <LinkListItem key={i} to={link.url} alt={label}>
              <Grid flexDirection="row" justifyContent="space-between">
                <Column width={[10 / 12]}>
                  <Grid flexDirection="row">
                    <Column width={[4 / 12]}>
                      <div>
                        <Text fontSize={[2, null, null, null, 3, 4]}>
                          {label}
                        </Text>
                      </div>
                    </Column>
                    <Column width={[6 / 12]}>
                      <Text
                        fontWeight="bold"
                        fontSize={[2, null, null, null, 3, 4]}
                      >
                        <span>{link.title ? link.title : href}</span>
                      </Text>
                    </Column>
                  </Grid>
                </Column>
                <Column width="auto">
                  <Text px={1} width="auto" fontWeight="bold">
                    ↗
                  </Text>
                </Column>
              </Grid>
            </LinkListItem>
          );
        } else {
          return null;
        }
      })}
    </LinkListStyles>
  );
};

export default LinkList;
